/**
 * PATH: packages/ui/src/components/settings/entities-tab/buildEntityTree.ts
 * PURPOSE: Pure helpers for corporate structure tree display.
 */

import type { EntityStructureNode, OrganisationEntity } from './entities-tab-types'

export function flattenStructureEntities(
  nodes: EntityStructureNode[],
  depth = 0,
): Array<{ node: EntityStructureNode; depth: number }> {
  const out: Array<{ node: EntityStructureNode; depth: number }> = []
  for (const node of nodes) {
    out.push({ node, depth })
    if (node.children?.length) {
      out.push(...flattenStructureEntities(node.children, depth + 1))
    }
  }
  return out
}

export function entityKindLabel(kind?: string): string {
  switch (kind) {
    case 'holding':
      return 'Holding'
    case 'mixed':
      return 'Holding + operating'
    default:
      return 'Operating'
  }
}

export function parentOptions(
  entities: OrganisationEntity[],
  excludeId: number,
): OrganisationEntity[] {
  return entities.filter((e) => e.id !== excludeId)
}
